import React from 'react'
import PropType from 'prop-types'

import logo from '../../images/brand/logo.svg'

function Logo({ className }) {
  return <img src={logo} alt="Hi Platform" className={className} />
}

Logo.propTypes = {
  className: PropType.string,
}

export default Logo



// WEBPACK FOOTER //
// ./src/components/Common/Logo.js